module.exports = __webpack_public_path__ + "static/media/AltaEficiencia.4ee66128.pdf";